import { Color } from '../entities/Color';
import {
  ALUMINIUM_COLOR,
  BLACK_OPAQUE_COLOR,
  DEFAULT_FROST_COLOR,
  DEFAULT_MDF_COLOR,
  GLASS_COLOR,
  MIRROR_COLOR,
  NATURAL_COLOR,
  PaneMaterial,
  WHITE_COLOR,
  WHITE_OPAQUE_COLOR,
} from '../constants';
import { getColors } from './dataStorage';

export const getMaterialColor = (color: Color): PaneMaterial => {
  const material = getMaterialColorInternal(color);

  if (!material) throw new Error(`Should have a material (${color.reference})`);

  return material;
};

export const hasMaterialColor = (color: Color): boolean => {
  return getMaterialColorInternal(color) !== null;
};

const getMaterialColorInternal = (color: Color): PaneMaterial | null => {
  /**
   * Find the material that is associate with the color based of the order of the colors
   */
  if (0 <= color.order && color.order < 100) return PaneMaterial.MDF;
  if (100 <= color.order && color.order < 200) return PaneMaterial.Frost;
  if (200 <= color.order && color.order < 300) return PaneMaterial.FrostOpaque;
  if (color.reference === GLASS_COLOR) return PaneMaterial.Glass;
  if (color.reference === MIRROR_COLOR) return PaneMaterial.Mirror;
  if (color.reference === ALUMINIUM_COLOR) return PaneMaterial.Alu;

  if (color.reference === 'BRUT-ECO' || color.reference === 'ECO-PLUS')
    return PaneMaterial.MDF;

  return null;
};

export function findColor(reference: string) {
  const colors = getColors();
  const color = colors.find(e => e.reference === reference);
  if (!color) {
    throw new Error(`The color ${reference} don't exist`);
  }
  return color;
}

export function findColorInReference(reference: string): Color | null {
  const regex = /\[(.+)\]/;
  const refColor = reference.match(regex);
  if (refColor) {
    const colors = getColors();
    const color = colors.find(e => e.reference === refColor[1]);
    if (!color) {
      throw new Error(`The color ${reference} don't exist`);
    }
    return color;
  }
  return null;
}

export function findColorById(id: number) {
  const colors = getColors();
  const color = colors.find(e => e.id === id);
  if (!color) {
    throw new Error(`The color with ${id} don't exist`);
  }
  return color;
}

export function getBaseColor(color: Color, isDrawer = false): Color {
  /**
   * Get the corresponding base color
   * Ex: for Door the color could be MDF Colors, Frost Colors, Glass, Miror, MDF Natural and MDF White
   */

  if (
    color.reference === NATURAL_COLOR ||
    color.reference === WHITE_COLOR ||
    color.reference === WHITE_OPAQUE_COLOR ||
    color.reference === BLACK_OPAQUE_COLOR ||
    color.reference === GLASS_COLOR ||
    color.reference === MIRROR_COLOR ||
    color.reference === ALUMINIUM_COLOR
  ) {
    return color;
  }
  try {
    const material = getMaterialColor(color);
    switch (material) {
      case PaneMaterial.MDF:
        if (isDrawer) return findColor(WHITE_COLOR);
        return findColor(DEFAULT_MDF_COLOR);
      case PaneMaterial.Frost:
      case PaneMaterial.FrostOpaque:
        return findColor(DEFAULT_FROST_COLOR);
      case PaneMaterial.Alu:
        return color;
      default:
        return color;
    }
  } catch (e) {
    return color;
  }
}
